export {
    ToolPropertiesFormComponent
} from "@app/tool/components/tool-batch-update-modal/forms/tool-properties-form/tool-properties-form.component";
